<script src="../tag-name.pipe.ts"></script>
<mat-chip-list>
    <mat-chip *ngFor="let tag of tags$ | async" [removable]="false">
        {{tag.id | tagName | async}}
    </mat-chip>
</mat-chip-list>
